var hotspotX = [];
var hotspotY = [];
var hotspotType = [];
var hotspotImage = [];
var hotspotAction = [];
